















import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/VenueWizard/VenueNavbar'
import WizardNavigation from '@ui/VenueWizard/WizardNavigation'
import SetupForm from '@ui/SpaceWizards/OnsiteSpaceWizard/Forms/SetupForm'

settings =
  name: 'OnsiteSpaceEditStep'

  resources:
    space_booth:
      resourceName: 'space_booth'
      slug: 'suppliers/:wizard.supplierId/space_booths/:spaceId/edit'

    availabilities:
      resourceName: 'audience_availability'
      slug: 'suppliers/:wizard.supplierId/spaces/:spaceId/audience_availabilities'
      fetch: false

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
      SetupForm,
    }

    computed:
      spaceId: ->
        @$route.query.spaceId

      form: ->
        data: @prime?.space_booth
        errors: @formErrors.space_booth || {}

      actionsForSetupForm: ->
        saveField: @saveField

    methods:
      saveField: (fieldName) ->
        @saveItem 'prime.space_booth', null, { skipFlash: true }

    watch:
      'wizard.audienceCreativeData': ->
        @fetch 'space_booth'

export default VueOptions.vue settings
